import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { formatCurrency } from '../../utils/currency';

const MyStatement = () => {
    const [d, setD] = useState(null);
    useEffect(() => {
        (async () => {
            try { const r = await axios.get('/api/portal/statement'); setD(r.data); }
            catch { toast.error('Failed'); }
        })();
    }, []);
    if (!d) return <div>Loading…</div>;
    const s = d.summary || {};
    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <h1 className="text-2xl font-bold">My statement</h1>
            <div className="grid md:grid-cols-3 gap-4">
                <StatCard label="Billed" value={formatCurrency(s.billed)} />
                <StatCard label="Paid" value={formatCurrency(s.paid)} />
                <StatCard label="Outstanding" value={formatCurrency(s.outstanding)} accent={s.outstanding>0?'text-red-600':'text-green-700'} />
            </div>
            <Section title="Invoices">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50"><tr><th className="p-2 text-left">#</th><th className="p-2 text-left">Due</th><th className="p-2 text-left">Type</th><th className="p-2 text-right">Total</th><th className="p-2 text-right">Paid</th><th className="p-2 text-right">Balance</th><th className="p-2">Status</th></tr></thead>
                    <tbody>{d.invoices.map(i => (
                        <tr key={i.id} className="border-t">
                            <td className="p-2 font-mono text-xs">{i.invoice_number}</td>
                            <td className="p-2">{new Date(i.due_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                            <td className="p-2 capitalize">{i.invoice_type}</td>
                            <td className="p-2 text-right">{formatCurrency(i.total_amount)}</td>
                            <td className="p-2 text-right">{formatCurrency(i.paid_amount)}</td>
                            <td className="p-2 text-right">{formatCurrency(i.balance_due)}</td>
                            <td className="p-2 capitalize">{i.status}</td>
                        </tr>
                    ))}</tbody>
                </table>
            </Section>
            <Section title="Payments">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50"><tr><th className="p-2 text-left">Date</th><th className="p-2 text-left">Method</th><th className="p-2 text-left">Reference</th><th className="p-2 text-left">Receipt</th><th className="p-2 text-right">Amount</th></tr></thead>
                    <tbody>{d.payments.map(p => (
                        <tr key={p.id} className="border-t">
                            <td className="p-2">{new Date(p.payment_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                            <td className="p-2">{p.payment_method}</td>
                            <td className="p-2 font-mono text-xs">{p.reference_number || '—'}</td>
                            <td className="p-2 font-mono text-xs">{p.receipt_number || '—'}</td>
                            <td className="p-2 text-right">{formatCurrency(p.amount)}</td>
                        </tr>
                    ))}</tbody>
                </table>
            </Section>
        </div>
    );
};
const StatCard = ({ label, value, accent }) => <div className="bg-white rounded-xl border p-4"><div className="text-sm text-gray-500">{label}</div><div className={`text-xl font-bold ${accent||''}`}>{value}</div></div>;
const Section = ({ title, children }) => <div className="bg-white rounded-xl border p-4"><h3 className="font-semibold mb-2">{title}</h3>{children}</div>;
export default MyStatement;
